import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nurseryai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveAuth(token, user) {
  localStorage.setItem("nurseryai_token", token);
  localStorage.setItem("nurseryai_user", JSON.stringify(user));
}
export function getUser() {
  try { return JSON.parse(localStorage.getItem("nurseryai_user")); } catch { return null; }
}
export function clearAuth() {
  localStorage.removeItem("nurseryai_token");
  localStorage.removeItem("nurseryai_user");
}
export function isAuthed() {
  return !!localStorage.getItem("nurseryai_token");
}
